import React, { useState, useEffect } from 'react';

const Visionn = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const sectionStyle = {
        padding: isMobile ? '0px' : '40px',
        margin: '0 auto',
    };

    const containerStyle = {
        maxWidth: isMobile ? '100%' : '1200px',
        margin: '0 auto',
        padding: '0 15px',
    };

    const rowStyle = {
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        justifyContent: 'center',
        gap: '20px',
    };

    const colStyle = {
        flex: '1',
        minWidth: isMobile ? '100%' : '300px',
        boxSizing: 'border-box',
        marginBottom: isMobile ? '20px' : '0',
    };

    const headingStyle = {
        textAlign: 'center',
        paddingBottom: '20px',
        fontSize: isMobile ? '24px' : '32px',
        color: '#343a40',
    };

    const visionContentStyle = {
        backgroundColor: '#F26820', //  Cabs color
        padding: '20px',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        textAlign: 'center',
        color: 'white',
    };

    const sectionTitleStyle = {
        color: '#2984C9', // Light color for titles
    };
    const sectionTitleStylee = {
        color: 'black'
    };

    return (
        <section style={sectionStyle}>
        <div style={containerStyle}>
            <h3 style={{ ...headingStyle, ...sectionTitleStyle }}>About Our Vision & Mission</h3>
            <div style={rowStyle}>
                <div style={colStyle}>
                    <div style={visionContentStyle}>
                        <h4 style={sectionTitleStylee}>Vision</h4>
                        <p className="text-white">
                            At Skyline Cabs, our vision is to redefine the transportation industry by providing safe, fast, and comfortable rides for everyone. We aim to deliver seamless, affordable, and high-quality services that cater to the needs of every passenger. Through innovation and technology, we aspire to make urban commuting stress-free and reliable.
                            
                            We envision a future where every ride is effortless, with a focus on sustainability, punctuality, and comfort. Whether you're heading to work, a social event, or exploring new locations, Skyline Cabs ensures that you travel with confidence and peace of mind.
                        </p>
                    </div>
                </div>
                <div style={colStyle}>
                    <div style={visionContentStyle}>
                        <h4 style={sectionTitleStylee}>Mission</h4>
                        <p className="text-white">
                            Our mission at Skyline Cabs is to provide exceptional transportation solutions that prioritize the comfort, safety, and satisfaction of our passengers. We are committed to offering punctual, affordable, and top-quality rides through professional drivers and well-maintained vehicles.
                            
                            We aim to enhance the customer experience by leveraging advanced technology for real-time tracking, transparent pricing, and easy booking options. Our mission is to deliver an unparalleled ride experience, ensuring convenience and peace of mind for every passenger, every time.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>
    );
};

export default Visionn;
